import {
  ClipboardDocumentCheckIcon,
  PencilSquareIcon,
  PhotoIcon,
  ShieldExclamationIcon,
  XCircleIcon,
} from '@heroicons/react/24/solid';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Chip,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  IconButton,
  Input,
  Option,
  Select,
  Tab,
  Tabs,
  TabsHeader,
  Tooltip,
  Typography,
} from '@material-tailwind/react';
import { useEffect, useState } from 'react';
import { getCookie } from '../../../utils/helper';
import { permissionLabel } from '../../../utils/permissions';
import {
  addUsers,
  checkUserNames,
  listUserID,
  updateUserID,
  listUserIDAll,
  listUserIDAllCount,
  listUserTeamAll,
} from '../../../services/apiUsers';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  InformationCircleIcon,
  MagnifyingGlassIcon,
  PencilIcon,
  UserMinusIcon,
  UserPlusIcon,
} from '@heroicons/react/24/outline';
import { addTeam, listAllTeam, updateTeam } from '../../../services/apiCategory';
const TABS = [
  {
    label: 'Tất Cả',
    value: '',
  },
  {
    label: 'Hoạt_Động',
    value: 1,
  },
  {
    label: 'Đã_Nghỉ',
    value: 2,
  },
];

const TABLE_HEAD = ['Tài khoản', 'Tên Team', 'Số điện thoại', 'Trạng thái', 'Ngày tạo', 'Tác vụ'];
export default function Users() {
  const auth = getCookie('token');
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const [resultListUsers, setResultListUsers] = useState([]);
  const [arrAllUser, setArrAllUser] = useState([]);

  const idUser = urlParams.get('u');
  const [resultAdminID, setResultAdminID] = useState({
    permission: 4,
    username: '',
    password: '',
    name: '',
    email: '',
    phone: '',
    address: '',
    status: 1,
    wifi: auth.wifi,
    id_team: 0,
    fteam: '',
    nameteam: '',
    viewsdt: 5,
    viewso: 30,
    viewkhoanggia: 50000000000,
    viewnoso: '0',
  });
  const [message, setMessage] = useState('');
  const [isCheckUserName, setIsCheckUserName] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [checkInfo, setCheckInfo] = useState(false);
  const [page, setPage] = useState(1);
  const [countUser, setCountUser] = useState(0);
  const [objBoLoc, setObjBoLoc] = useState({ status: '1', username: '' });
  const [isDisabled, setIsDisabled] = useState(false);

  const [openDetail, setOpenDetail] = useState(false);

  const [resultAdminIDTeam, setResultAdminIDTeam] = useState({
    id: '',
    id_team: 0,
    fteam: '',
    username: '',
    nameteam: '',
  });
  const [resultAllTeam, setResultAllTeam] = useState([]);
  const [isEditTeam, setIsEditTeam] = useState(false);
  const [arrTeam, setArrTeam] = useState({
    id_user: auth.id,
    name: '',
    status: 1,
  });

  const [objLuotXemSDT, setObjLuotXemSDT] = useState({
    viewsdt: '',
    viewso: '',
    viewkhoanggia: '',
    viewnoso: '0', // 0 = cho xem sổ, 1 = không cho xem sổ
  });

  const updateLuotXemUser = (auth) => {
    if (auth.permission === 1) {
      setResultAdminID({
        ...resultAdminID,
        ...auth,
        viewsdt: 10000,
        viewso: 10000,
        viewkhoanggia: 10000000000000,
        viewnoso: '0',
      });
    }
    if (auth.permission === 2) {
      setResultAdminID({
        ...resultAdminID,
        ...auth,
        viewsdt: 30,
        viewso: 100,
        viewkhoanggia: 50000000000,
        viewnoso: '0',
      });
    }

    if (auth.permission === 3) {
      setResultAdminID({
        ...resultAdminID,
        ...auth,
        viewsdt: 30,
        viewso: 100,
        viewkhoanggia: 50000000000,
        viewnoso: '0',
      });
    }

    if (auth.permission === 4) {
      setResultAdminID({
        ...resultAdminID,
        ...auth,
        viewsdt: 5,
        viewso: 30,
        viewkhoanggia: 50000000000,
        viewnoso: '0',
      });
    }
  };
  const changeValueAdmin = (jsonVL) => {
    if (jsonVL.permission) {
      console.log(1);
      updateLuotXemUser(jsonVL);
    } else {
      setResultAdminID({ ...resultAdminID, ...jsonVL });
    }
  };

  useEffect(() => {
    document.title = 'Thông tin cá nhân';
    getUserID(idUser);
  }, [idUser]);

  const getUserID = async (idUser) => {
    if (idUser) {
      const resultUserID = await listUserID(idUser);
      // console.log(resultUserID);
      if (resultUserID.length > 0) {
        setCheckInfo(true);
        setResultAdminID({
          permission: resultUserID[0].permission,
          username: resultUserID[0].username,
          name: resultUserID[0].name,
          email: resultUserID[0].email,
          phone: resultUserID[0].phone,
          address: resultUserID[0].address,
          status: resultUserID[0].status,
          id_team: resultUserID[0].id_team,
          fteam: resultUserID[0].fteam,
          nameteam: resultUserID[0].nameteam,
        });
      } else {
        setCheckInfo(false);
      }
    }
  };

  const addUser = async () => {
    const { nameteam, ...rest } = resultAdminID;
    const resultAPISIM = await addUsers(rest);
    if (resultAPISIM.message === 'OK') {
      setIsDisabled(false);
      setMessage('Thành Công');
      setOpenAlert(true);
      setResultAdminID({
        permission: 4,
        username: '',
        password: '',
        name: '',
        email: '',
        phone: '',
        address: '',
        status: 1,
        wifi: auth.wifi,
        id_team: 0,
        fteam: '',
        nameteam: '',
        viewsdt: 5,
        viewso: 30,
        viewkhoanggia: 50000000000,
        viewnoso: '0',
      });
    } else {
      setIsDisabled(false);
      setMessage('Thất Bại');
      setOpenAlert(true);
    }
  };
  const updateUser = async () => {
    const { nameteam, ...rest } = resultAdminID;
    const body = {
      id: idUser,
      data: rest,
    };
    const resultAPISIM = await updateUserID(body);
    if (resultAPISIM?.message === 'OK') {
      navigate('/dsusers');
    }
  };

  const checkUserName = async (user) => {
    const resultUser = await checkUserNames(user);
    if (resultUser?.totalRows > 0) {
      setIsDisabled(true);
      setIsCheckUserName(true);
    } else {
      setIsDisabled(false);
      setIsCheckUserName(false);
    }
  };

  const handleOpen = () => setOpenDetail(!openDetail);

  const listUserAll = async (isstatus = '', username = '', pages = 1) => {
    const resultUserAll = await listUserTeamAll(isstatus, username, pages);
    // console.log(resultUserAll);
    if (resultUserAll.length > 0) {
      setResultListUsers(resultUserAll);
      const countUser = await listUserIDAllCount(isstatus, username);
      setCountUser(countUser.totalRows);
    } else {
      setResultListUsers([]);
    }
  };

  const listUserAllSelect = async () => {
    const resultUserAll = await listUserIDAll('', '', 1, 1000);
    if (resultUserAll.length > 0) {
      setArrAllUser(resultUserAll);
    } else {
      setArrAllUser([]);
    }
  };

  const listTeam = async () => {
    const resulAll = await listAllTeam(1, 500);
    if (resulAll.length > 0) {
      setResultAllTeam(resulAll);
    } else {
      setResultAllTeam([]);
    }
  };

  useEffect(() => {
    listUserAll(1);
    listUserAllSelect();
    listTeam();
    document.title = 'Danh sách team nhân viên';
  }, []);

  const handleEnterKey = (e) => {
    if (e.key === 'Enter') {
      listUserAll(objBoLoc.status, objBoLoc.username, 1);
    }
  };

  const addTeams = async () => {
    setIsDisabled(true);
    const resultAPISIM = await addTeam(arrTeam);
    if (resultAPISIM.message === 'OK') {
      setIsDisabled(false);
      setMessage('Thành Công');
      setOpenAlert(true);
      setArrTeam({
        id_user: auth.id,
        name: '',
        status: 1,
      });
    } else {
      setIsDisabled(false);
      setMessage('Thất Bại');
      setOpenAlert(true);
    }
  };
  const updateTeams = async () => {
    setIsDisabled(true);
    const body = {
      id: arrTeam.id,
      data: arrTeam,
    };
    const resultAPISIM = await updateTeam(body);
    if (resultAPISIM.message === 'OK') {
      setIsDisabled(false);
      setMessage('Thành Công');
      setOpenAlert(true);
      setArrTeam({
        id_user: auth.id,
        name: '',
        status: 1,
      });
    } else {
      setIsDisabled(false);
      setMessage('Thất Bại');
      setOpenAlert(true);
    }
  };

  const nextPage = () => {
    const total = Math.ceil(countUser / 50);
    if (total > page) {
      setPage(page + 1);
      listUserAll(objBoLoc.status, objBoLoc.username, page + 1);
    }
  };

  const prevPage = () => {
    const total = Math.ceil(countUser / 50);
    if (total <= page && page > 1) {
      setPage(page - 1);
      listUserAll(objBoLoc.status, objBoLoc.username, page - 1);
    }
  };

  const alertRemoveUser = async (id, status) => {
    if (
      window.confirm(status === 1 ? `Bạn đã chắc chắn NGỪNG HOẠT ĐỘNG USER` : `Bạn muốn cho USER HOẠT ĐỘNG chở lại`)
    ) {
      // Save it!
      const body = {
        id: id,
        data: { status: status === 1 ? 2 : 1 },
      };
      const resultAPISIM = await updateUserID(body);
      if (resultAPISIM?.message === 'OK') {
        listUserAll(objBoLoc.status, objBoLoc.username, 1);
      }
    } else {
      // Do nothing!
      console.log('Hủy yêu cầu');
    }
  };

  const openUser = async (id, username) => {
    if (window.confirm(`Bạn muốn mở khóa cho tài khoản ${username}`)) {
      // Save it!
      const body = {
        id: id,
        data: { numberlogin: 0 },
      };
      const resultAPISIM = await updateUserID(body);
      if (resultAPISIM?.message === 'OK') {
        listUserAll(objBoLoc.status, objBoLoc.username, 1);
      }
    } else {
      // Do nothing!
      console.log('Hủy yêu cầu');
    }
  };

  const changeValueAdminTeam = (jsonVL) => {
    setResultAdminIDTeam({ ...resultAdminIDTeam, ...jsonVL });
  };

  const updateTeamUser = async () => {
    const body = {
      id: resultAdminIDTeam?.id,
      data: { id: resultAdminIDTeam.id, id_team: resultAdminIDTeam.id_team, fteam: resultAdminIDTeam.fteam },
    };
    const resultAPISIM = await updateUserID(body);
    if (resultAPISIM.message === 'OK') {
      setIsDisabled(false);
      setMessage('Thành Công');
      setOpenAlert(true);
      setResultAdminIDTeam({
        id: '',
        fteam: '',
        id_team: 0,
        username: '',
        nameteam: '',
      });
      listUserAll(1);
    } else {
      setIsDisabled(false);
      setMessage('Thất Bại');
      setOpenAlert(true);
    }
  };

  return (
    <>
      <div className="grid grid-cols-6 gap-4">
        <div className="col-span-6 lg:col-start-1 lg:col-span-5">
          <div className="flex justify-between">
            <h2 className="font-bold mb-2 text-xl text-orange-800">
              {checkInfo ? 'CẬP NHẬT THÔNG TIN' : 'THÊM NHÂN VIÊN'} /{' '}
              <Link to="/dsusers">
                <Button className="gap-2 bg-gradient-to-r from-teal-400 to-blue-500" size="sm">
                  Dah Sách Nhân Viên
                </Button>
              </Link>
            </h2>
          </div>

          <Card className="p-2">
            <Alert
              color={message === 'Thành Công' ? 'green' : 'red'}
              className="mb-2"
              open={openAlert}
              onClose={() => setOpenAlert(false)}
            >
              {message === 'Thành Công' ? 'Cập Nhật Thành Công' : 'Cập Nhật Thất Bại'}
            </Alert>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <Input
                  value={resultAdminID?.username}
                  onChange={(e) => {
                    changeValueAdmin({ username: e.target.value });
                    checkUserName(e.target.value);
                  }}
                  disabled={checkInfo ? true : false}
                  label="Tài khoản (viết liền không dấu)"
                  placeholder="Nhập tài khoản (vd: kland01)"
                  required
                />
                {isCheckUserName && (
                  <div className="mt-2 flex items-center gap-1 font-normal text-red-500">
                    <ShieldExclamationIcon className="h-5 w-5" />
                    <b> tài khoản này đã tồn tại</b>
                  </div>
                )}
              </div>
              <div>
                <Input
                  value={resultAdminID?.password}
                  onChange={(e) => {
                    changeValueAdmin({ password: e.target.value });
                  }}
                  label="Mật khẩu"
                  placeholder="Nhập mật khẩu"
                  required
                />
              </div>
              <div>
                <Select
                  label="Chức vụ"
                  value={`${resultAdminID?.permission}`}
                  onChange={(e) => {
                    changeValueAdmin({ permission: Number(e) });
                  }}
                >
                  <Option value={'1'}>Quản Trị</Option>
                  <Option value={'2'}>Kiểm Duyệt Viên</Option>
                  <Option value={'3'}>Quản Lý</Option>
                  <Option value={'4'}>Sale</Option>
                </Select>
              </div>
              <div>
                <Input
                  value={resultAdminID?.name}
                  onChange={(e) => {
                    changeValueAdmin({ name: e.target.value });
                  }}
                  placeholder="Nhập họ và tên"
                  label="Họ và Tên"
                />
              </div>
              <div>
                <Input
                  value={resultAdminID?.email}
                  onChange={(e) => {
                    changeValueAdmin({ email: e.target.value });
                  }}
                  placeholder="Nhập email"
                  label="Email"
                />
              </div>
              <div>
                <Input
                  value={resultAdminID?.phone}
                  onChange={(e) => {
                    changeValueAdmin({ phone: e.target.value });
                  }}
                  placeholder="Nhập số điện thoại"
                  label="Số điện thoại"
                />
              </div>
              <div>
                <Input
                  value={resultAdminID?.address}
                  onChange={(e) => {
                    changeValueAdmin({ address: e.target.value });
                  }}
                  placeholder="Nhập địa chỉ"
                  label="Địa chỉ"
                />
              </div>

              <div>
                <Select label="TÊN TEAM (NHÓM)" value={`${resultAdminID?.nameteam}`}>
                  {resultAllTeam &&
                    resultAllTeam.map((row, i) => (
                      <Option
                        key={i}
                        value={row.id}
                        onClick={() => {
                          changeValueAdmin({ id_team: row.id, nameteam: row.name });
                        }}
                      >
                        {row.name}
                      </Option>
                    ))}
                </Select>
              </div>
              <div>
                {/* {resultAdminID?.fteam === '1'
                  ? 'F1: Trưởng Nhóm'
                  : resultAdminID?.fteam === '2'
                  ? 'F2: Leader'
                  : resultAdminID?.fteam === '3'
                  ? 'F3: CVKD'
                  : ''} */}
                <Select
                  label="CHỌN CHỨC VỤ TRONG TEAM"
                  value={String(resultAdminID?.fteam || '')}
                  onChange={(e) => {
                    changeValueAdmin({ fteam: Number(e) });
                  }}
                >
                  <Option value={'1'}>F1: Trưởng Nhóm</Option>
                  <Option value={'2'}>F2: Leader</Option>
                  <Option value={'3'}>F3: CVKD</Option>
                </Select>
              </div>

              <div className="mb-2">
                {checkInfo ? (
                  <Button
                    className="bg-gradient-to-r from-yellow-600 to-orange-500 w-full"
                    disabled={isDisabled}
                    onClick={updateUser}
                  >
                    Cập nhật
                  </Button>
                ) : (
                  <Button
                    className="bg-gradient-to-r from-orange-400 to-orange-900 w-full"
                    disabled={isDisabled}
                    onClick={addUser}
                  >
                    Lưu lại
                  </Button>
                )}
              </div>
            </div>
          </Card>
        </div>
      </div>
      <hr className="my-2 border-blue-gray-100 mb-4" />
      <div className="mt-4">
        <Dialog open={openDetail} handler={handleOpen}>
          <DialogHeader className="font-[UTM-Avo]">DANH SÁCH TEAM</DialogHeader>

          <DialogBody className="overflow-scroll leading-8 font-[500]">
            <table className="mt-4 w-full min-w-max table-auto text-left">
              <thead>
                <tr>
                  <th className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4">
                    <Typography variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                      STT
                    </Typography>
                  </th>
                  <th className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4">
                    <Typography variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                      TÊN TEAM
                    </Typography>
                  </th>
                  <th className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4">
                    <Typography variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                      NGÀY TẠO
                    </Typography>
                  </th>
                  <th className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4">
                    <Typography variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                      TÁC VỤ
                    </Typography>
                  </th>
                </tr>
              </thead>
              <tbody>
                {resultAllTeam.map((row, index) => {
                  const isLast = index === resultAllTeam.length - 1;
                  const classes = isLast ? 'p-4' : 'p-4 border-b border-blue-gray-50';

                  return (
                    <tr key={index}>
                      <td className={classes}>
                        <div className="flex items-center gap-3">
                          <div className="flex flex-col">
                            <label className="font-normal text-base">
                              <b>{index + 1}</b>
                            </label>
                          </div>
                        </div>
                      </td>
                      <td className={classes}>
                        <div className="flex flex-col">
                          <label className="font-normal text-base">{row.name}</label>
                        </div>
                      </td>
                      <td className={classes}>
                        <label className="font-normal text-base">{row?.create_date}</label>
                      </td>
                      <td className={classes}>
                        <Tooltip content="Sửa">
                          <IconButton variant="text">
                            <PencilIcon
                              className="h-4 w-4"
                              onClick={() => {
                                setArrTeam({ ...arrTeam, name: row.name, id: row.id });
                                setIsEditTeam(true);
                                handleOpen();
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </DialogBody>
          <DialogFooter>
            <Button variant="text" color="red" onClick={handleOpen} className="mr-1">
              <span>Đóng</span>
            </Button>
          </DialogFooter>
        </Dialog>
        <Card className="w-full bg-yellow-50">
          <CardHeader floated={false} shadow={false} className="p-2 rounded-lg border border-yellow-500">
            <div className="mb-8 flex items-center justify-between gap-8">
              <div>
                <div className="text-xl font-bold">DANH SÁCH NHÂN VIÊN</div>
                {/* <Typography color="gray" className="mt-1 font-normal">
              Tất cả nhân viên đang hoạt động và đã nghỉ
            </Typography> */}
              </div>
              <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
                {/* <Button variant="outlined" size="sm">
              view all
            </Button> */}
                {/* <Link to="/users">
                  <Button className="flex items-center gap-3 bg-amber-900" size="sm">
                    <UserPlusIcon strokeWidth={2} className="h-4 w-4" /> Thêm Nhân Viên Mới
                  </Button>
                </Link> */}
              </div>
            </div>
            <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
              <Tabs value={1} className="w-full md:w-max">
                <TabsHeader>
                  {TABS.map(({ label, value }) => (
                    <Tab
                      key={value}
                      value={value}
                      onClick={() => {
                        listUserAll(value, objBoLoc.username, 1);
                        setObjBoLoc({ ...objBoLoc, status: value });
                      }}
                    >
                      &nbsp;&nbsp;{label}&nbsp;&nbsp;
                    </Tab>
                  ))}
                </TabsHeader>
              </Tabs>
              <div className="w-full md:w-80">
                <Input
                  label="Tìm kiếm theo tài khoản"
                  value={objBoLoc?.username}
                  icon={<MagnifyingGlassIcon className="h-5 w-5" />}
                  onChange={(e) => setObjBoLoc({ ...objBoLoc, username: e.target.value })}
                  onKeyPress={handleEnterKey}
                />
                <Typography variant="small" color="gray" className="mt-2 flex items-center gap-1 font-normal">
                  <InformationCircleIcon className="h-4 w-4" />
                  Nhập tài khoản tìm kiếm và sau đó ấn enter
                </Typography>
              </div>
            </div>
          </CardHeader>
          <CardBody className="overflow-auto px-0">
            {' '}
            <Alert
              color={message === 'Thành Công' ? 'green' : 'red'}
              className="mb-2"
              open={openAlert}
              onClose={() => setOpenAlert(false)}
            >
              {message === 'Thành Công' ? 'Cập Nhật Thành Công' : 'Cập Nhật Thất Bại'}
            </Alert>
            <div className="text-lg font-bold mb-1 text-green-500 ml-2">TẠO TEAM MỚI (NẾU CHƯA CÓ)</div>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 ml-2 ">
              <div className="col-span-2">
                <Input
                  value={arrTeam?.name}
                  onChange={(e) => {
                    setArrTeam({ ...arrTeam, name: e.target.value });
                  }}
                  placeholder="Tên Team"
                  label="Tên Team"
                />
                <div>
                  <span
                    className="text-blue-800 cursor-pointer underline"
                    onClick={() => {
                      handleOpen();
                      listTeam();
                    }}
                  >
                    Danh sách team
                  </span>
                </div>
              </div>

              <div>
                {' '}
                <Button
                  className="bg-gradient-to-r from-red-400 to-blue-900 w-full"
                  disabled={isDisabled}
                  onClick={isEditTeam ? updateTeams : addTeams}
                >
                  {isEditTeam ? 'Cập nhật' : 'Lưu Mới'}
                </Button>
              </div>
            </div>
            <div className="text-lg font-bold mb-1 text-green-500 ml-2">CẬP NHẬT TÀI KHOẢN VÀO TEAM</div>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 ml-2">
              <div>
                <Select label="TÀI KHOẢN" value={`${resultAdminIDTeam?.username}`}>
                  {arrAllUser &&
                    arrAllUser?.map((row, i) => (
                      <Option
                        key={i}
                        value={row.id}
                        onClick={() => {
                          changeValueAdminTeam({ id: row.id, username: row.username });
                        }}
                      >
                        {row.username} ({row.name})
                      </Option>
                    ))}
                </Select>
              </div>
              <div>
                <Select label="TÊN TEAM (NHÓM)" value={`${resultAdminIDTeam?.nameteam}`}>
                  {resultAllTeam &&
                    resultAllTeam.map((row, i) => (
                      <Option
                        key={i}
                        value={row.id}
                        onClick={() => {
                          changeValueAdminTeam({ id_team: row.id, nameteam: row.name });
                        }}
                      >
                        {row.name}
                      </Option>
                    ))}
                </Select>
              </div>
              <div>
                <Select
                  label="CHỌN CHỨC VỤ TRONG TEAM"
                  value={`${
                    resultAdminIDTeam?.fteam === '1'
                      ? 'F1: Trưởng Nhóm'
                      : resultAdminIDTeam?.fteam === '2'
                      ? 'F2: Leader'
                      : resultAdminIDTeam?.fteam === '3'
                      ? 'F3: CVKD'
                      : ''
                  }`}
                  onChange={(e) => {
                    changeValueAdminTeam({ fteam: Number(e) });
                  }}
                >
                  <Option value={'1'}>F1: Trưởng Nhóm</Option>
                  <Option value={'2'}>F2: Leader</Option>
                  <Option value={'3'}>F3: CVKD</Option>
                </Select>
              </div>
              <Button
                className="bg-gradient-to-r from-red-400 to-blue-900 w-full"
                disabled={isDisabled}
                onClick={updateTeamUser}
              >
                Lưu lại
              </Button>
            </div>
            <table className="mt-4 w-full min-w-max table-auto text-left">
              <thead>
                <tr>
                  {TABLE_HEAD.map((head) => (
                    <th key={head} className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4">
                      <Typography variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {resultListUsers.map((row, index) => {
                  const isLast = index === resultListUsers.length - 1;
                  const classes = isLast ? 'p-4' : 'p-4 border-b border-blue-gray-50';

                  return (
                    <tr key={index}>
                      <td className={classes}>
                        <div className="flex items-center gap-3">
                          <div className="flex flex-col">
                            <label className="font-normal text-base">
                              <b>{row.username}</b>
                            </label>
                            <label className="font-normal text-sm opacity-70">
                              {row.name} ({permissionLabel(row)})
                            </label>
                          </div>
                        </div>
                      </td>
                      <td className={classes}>
                        <div className="flex flex-col">
                          <label className="font-normal text-base">
                            {row.nameteam ? row.nameteam : 'Chưa vào Team'}
                          </label>
                          <label className="font-normal text-sm opacity-70">
                            {row.fteam === '1'
                              ? '(F1: Trưởng Nhóm)'
                              : row.fteam === '2'
                              ? '(F2: Leader)'
                              : row.fteam === '3'
                              ? '(F3: CVKD)'
                              : ''}
                          </label>
                        </div>
                      </td>

                      <td className={classes}>
                        <label className="font-normal text-base">{row.phone}</label>
                      </td>
                      <td className={classes}>
                        <div className="w-max">
                          <Chip
                            variant="ghost"
                            size="sm"
                            value={row.numberlogin >= 5 ? 'Đã bị khóa' : row.status === 1 ? 'Hoạt động' : 'Đã nghỉ'}
                            color={row.numberlogin >= 5 ? 'red' : row.status === 1 ? 'green' : 'blue-gray'}
                          />
                        </div>
                      </td>

                      <td className={classes}>
                        <label className="font-normal text-base">{row?.create_date}</label>
                      </td>
                      <td className={classes}>
                        {row.numberlogin >= 5 && (
                          <Tooltip content="Mở Khóa tài khoản">
                            <IconButton variant="filled" color="green" onClick={() => openUser(row.id, row.username)}>
                              MỞ KHÓA
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip content="Sửa User">
                          <Link to={`/users?u=${row.id}`}>
                            <IconButton variant="text">
                              <PencilIcon className="h-4 w-4" />
                            </IconButton>
                          </Link>
                        </Tooltip>

                        <Tooltip content={`${row.status === 1 ? 'Ngưng hoạt động' : 'Hoạt động lại'}`}>
                          <IconButton variant="text" onClick={() => alertRemoveUser(row.id, row.status)}>
                            <UserMinusIcon
                              className={`h-4 w-4 ${row.status === 1 ? 'text-red-500' : 'text-green-500'}`}
                            />
                          </IconButton>
                        </Tooltip>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </CardBody>
          {Math.ceil(countUser / 50) > page && (
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Typography variant="small" color="blue-gray" className="font-normal">
                Page {page} of {Math.ceil(countUser / 50)}
              </Typography>
              <div className="flex gap-2">
                <Button variant="outlined" size="sm" onClick={prevPage}>
                  Trang Trước
                </Button>
                <Button variant="outlined" size="sm" onClick={nextPage}>
                  Trang Tiếp
                </Button>
              </div>
            </CardFooter>
          )}
        </Card>
      </div>
    </>
  );
}
